/**
 * アプリケーション設定
 */

import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import {
  baseUrlInterceptor,
  tokenInterceptor,
  errorInterceptor,
} from './core/interceptors';
import { provideUpdateNotificationGuard } from '@interserve/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([baseUrlInterceptor, tokenInterceptor, errorInterceptor])
    ),
    provideAnimationsAsync(),
    // View 定義の APP_INITIALIZER 先読みは本地 mock 時代に使用していた処理。
    // 後端接入後は BizFrontend 初期化完了後に AppComponent から読み込むため、ここでは有効化しない。
    // 更新検知: 猶予付き強制更新と促す更新を UX で表示
    ...provideUpdateNotificationGuard({
      versionUrl: '/version.json',
      checkIntervalMs: 60 * 1000, // 60秒ごとにチェック
      criticalGraceSeconds: 10,
    }),
  ],
};
